
export const isNumeric: (value: string) => boolean = (value: string) => {
  return value.trim() !== '' && Number.isFinite(Number(value));
}